<template>
    <div 
        class="gz-option-select" 
        :class="{'gz-option-select_disabled': disabled}"
        @click.stop="!onlyChecked ? [selected = !selected, $emit('click'), getStatus()] : false"
        :title="onlyChecked ? 'Опция может быть только активной' : ''"
    >
        <span v-if="!selected" class="icon-checkbox-unchecked gz-option-select__icon"></span>
        <span v-else class="icon-checkbox-checked gz-option-select__icon"></span>
        <span v-if="!hint" class="gz-option-select__value">{{ computedValue }}</span>
        <GZ-BaseHint v-else hintClass="disp-ib" :hint="hint">
            <span class="gz-option-select__value">{{ computedValue }}</span>
        </GZ-BaseHint>        
    </div>
</template>

<script>
export default {
    name: 'BaseSelect',

    props: {
        value: String,
        checked: Boolean,
        importedData: {
            type: Boolean,
            default: false
        },
        hint: {
            type: String,
            default: ''
        },
        onlyChecked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selected: this.importedData ? this.importedData : this.checked
        }
    },
    computed: {
        computedValue() {
            return this.value
        }
    },
    mounted() {
        this.setOnlyChecked()
    },
    methods: {
        getStatus() {
            this.$emit('update:select', this.selected)
        },
        setOnlyChecked() {
            if (this.onlyChecked) this.selected = true
        }
    },
    watch: {
        importedData: function (val) {
            if (val) {
                this.selected = true
                this.getStatus()
            } else {
                this.selected = false
                this.getStatus()
            }
        },
        checked: function (val) {
            if (val === false) {
                this.selected = false
            }
        }
    }
}
</script>